export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/glow.b09df25c-fca0b7.svg";